/* app/js/src/components/autopilot/autopilot.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.root-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.main-panel {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
icn-sidebar-nav {
  z-index: 4;
}
/*# sourceMappingURL=autopilot.component.css.map */
